import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AIFinalCTASection.module.css';

export function AIFinalCTASection() {
  return (
    <SectionWrapper background="white" data-testid="ai-section-final-cta">
      <div className={styles.section}>
        <p className={styles.eyebrow}>KAI</p>
        <h2 className={styles.title}>
          The AI position higher ed has been waiting for.
        </h2>
        <p className={styles.subhead}>
          Equity. Pedagogy. Privacy. Validated outcomes. And it costs your
          institution less than what you&apos;re paying for AI subscriptions
          today.
        </p>
        <div className={styles.actions}>
          <PrimaryCTA
            className={styles.primary}
            href="/contact"
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Book a mapping call"
          />
          <SecondaryCTA
            className={styles.secondary}
            href="/faculty"
            label="Try KAI free as faculty"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
